import { IMenu } from 'components/header/types';

export enum GeneralActionsType {
  SET_MENU = 'SET_MENU',
  SET_HOME = 'SET_HOME',
  SET_EVENTS_PAGES = 'SET_EVENTS_PAGE'
}

interface SetMenuAction {
  type: GeneralActionsType.SET_MENU
  payload: IMenu | null;
}

interface SetHomeAction {
  type: GeneralActionsType.SET_HOME
  payload: any | null;
}

interface SetEventsPagesAction {
  type: GeneralActionsType.SET_EVENTS_PAGES
  payload: any | null;
}

export type GeneralActions = SetMenuAction | SetHomeAction | SetEventsPagesAction;

export interface GeneralState {
  menu: IMenu | null;
  home: any | null;
  events: any | null;
}

export const initialState: GeneralState = {
  menu: null,
  home: null,
  events: null
};

export const generalReducer = (state: GeneralState, action: GeneralActions): GeneralState => {
  switch (action.type) {
  case GeneralActionsType.SET_MENU:
    return {
      ...state,
      menu: action.payload,
    };
  case GeneralActionsType.SET_HOME:
    return {
      ...state,
      home: action.payload,
    };
  case GeneralActionsType.SET_EVENTS_PAGES:
    return {
      ...state,
      events: action.payload,
    };
  default:
    return state;
  }
};
